<template>
  <div class="form-group artwork-logo-picker">
    <label class="mb-1"><strong>Logos na arte</strong></label>
    <div v-if="loading" class="text-muted small">
      <i class="fa fa-spinner fa-spin mr-1"></i> Carregando logos...
    </div>
    <div v-else-if="!logos.length" class="text-muted">
      Nenhuma logo configurada · <router-link to="/pmau-configuracao">Cadastrar</router-link>
    </div>
    <div v-else class="d-flex flex-wrap">
      <label
        v-for="logo in logos"
        :key="logo.code"
        class="logo-option mr-2 mb-2"
        :class="{ selected: value.includes(logo.code), disabled: disabled }"
      >
        <input
          type="checkbox"
          class="mr-2"
          :checked="value.includes(logo.code)"
          :disabled="disabled"
          @change="toggle(logo.code, $event.target.checked)"
        />
        <img :src="logo.url" :alt="logo.label" class="logo-thumb mr-2" />
        <span class="small">{{ logo.label }}</span>
      </label>
    </div>
  </div>
</template>

<script>
import ArtworkService from "../servico/ArtworkService";

// Seleção das logos que entram na arte de divulgação. v-model = lista de codes marcados;
// ao carregar, marca todas as configuradas.
export default {
  name: "ArtworkLogoPicker",
  props: {
    value: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return { loading: false, logos: [] };
  },
  beforeMount() {
    this.loadLogos();
  },
  methods: {
    loadLogos() {
      const contaId = this.$store.getters.getAutenticacao?.contaSelecionada?.id;
      if (!contaId) return;
      this.loading = true;
      ArtworkService.GetLogos(contaId)
        .then((r) => {
          this.logos = r.data;
          this.$emit("input", this.logos.map((l) => l.code));
        })
        .catch((e) => { this.$notify({ data: [e.message], type: "error" }); })
        .finally(() => { this.loading = false; });
    },
    toggle(code, checked) {
      const codes = this.logos
        .map((l) => l.code)
        .filter((c) => (c === code ? checked : this.value.includes(c)));
      this.$emit("input", codes);
    },
  },
};
</script>

<style scoped>
.logo-option {
  display: flex;
  align-items: center;
  padding: 6px 10px;
  border: 1px solid #d8dbe0;
  border-radius: 6px;
  cursor: pointer;
  background: #fff;
}
.logo-option.selected {
  border-color: #2eb85c;
  background: #f1faf4;
}
.logo-option.disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
.logo-thumb {
  height: 32px;
  max-width: 110px;
  object-fit: contain;
}
</style>
